// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu-item-m__wrapper__Z_5Fz"};